import { format, parseISO } from 'date-fns';
import { themeValue } from './themeSelectors';

export const mapableEnum = <T extends {}>(object: T): (keyof T)[] => {
  return Object.values(object) as (keyof T)[];
};

export const toPrettyDate = (
  date: string | null | undefined,
  fmt: string = 'MMMM dd, yyyy',
) => {
  if (!date) return date;
  try {
    return format(parseISO(date), fmt);
  } catch (e) {
    return date;
  }
};

export const unique = (value: unknown, index: number, self: unknown[]) => {
  return self.indexOf(value) === index;
};

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidUuid = (value: string | undefined | null): value is string =>
  !!value && UUID_REGEX.test(value);

export const isSidebar = () =>
  window.innerWidth > parseInt(themeValue('media')('l'), 10);
export const isMobile = () =>
  window.innerWidth <= parseInt(themeValue('media')('l'), 10);
